import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Row, Col, notification } from 'antd'
import Auth from '~/modules/Auth'

import ModalForm from './Form'

import './style.scss'
import PreviewMessage from './PreviewMessage'

const defaultData = {
    loading: false,

    id: null,
    clientName: '',
    clientEmail: '',
    clientMessage: 'As suas fotos já estão disponíveis, estou te enviando o link de acesso para escolher as que você mais gostar.',
    limitDate: undefined,
    allowDownload: false,
    contractedPictures: 0,
    allowExtraPictures: false,
    extraPicturePrice: 0,

    isValidEmail: false
}


class SelectionModal extends React.PureComponent {
  static propTypes = {
    data: PropTypes.any,
    hide: PropTypes.func,
    type: PropTypes.string,
  }

  constructor (props, context) {
    super(props, context)
    this.state = {
      ...defaultData,
      ...this.props.data,
      visible: true
    }

    this.close = () => {
      this.setState({ ...defaultData, visible: false })
      setTimeout(() => this.props.hide(), 250)
    }
  }

  onCancel () {
    this.close()
  }

  async onOk () {
    this.setState({ loading: true })

    await this.props.postData({
      collection_id: this.props.collectionId,
      action: this.props.type,
      customerName: Auth.userData.displayName,
      customerEmail: Auth.userData.email,
      ...this.state,
    })

    if (!this.state.id) {
      notification.success({ message: 'Seleção adicionada!' })
    } else if (this.props.type === 'resend') {
      notification.success({ message: 'Seleção reenviada!' })
    } else {
      notification.success({ message: 'Dados atualizados!' })
    }

    this.close()
  }

  onChange (value, key) {
    if (!key) {
      key = value.target.name
      value = value.target.value
    }

    const newState = { [key]: value }

    if (key === 'clientEmail') {
      newState[key] = newState[key].trim()
      newState.isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    }

    this.setState(newState)
  }

  render() {

    return (
    <Modal {...(this.getModalSettings())}>
      <Row>
        <Col span={this.props.type === 'edit' ? 24 : 14}>
        {this.props.selectionId}
          <ModalForm
            modalType={this.props.type}
            selectionId={this.props.selectionId}
            data={this.state}
            onChange={this.onChange.bind(this)}
          />
        </Col>
        {this.props.type !== 'edit' && (
          <Col span={10}>
            <PreviewMessage data={this.state} />
          </Col>
        )}
      </Row>
    </Modal>
    )
  }

  getModalSettings () {
    const settings = {
      visible: this.state.visible,
      title: 'Seleção',
      okText: 'Salvar',
      okButtonProps: {
        icon: 'check',
        disabled: this.props.type === 'new' && !this.state.isValidEmail
      },
      cancelText: 'Cancelar',
      zIndex: 99990,
      onCancel: this.onCancel.bind(this),
      onOk: this.onOk.bind(this),
      centered: true,
      confirmLoading: this.state.loading
    }

    if (this.props.type !== 'edit') {
      settings.title = 'Enviar a coleção para um cliente'
      settings.okText = 'Salvar e enviar'
      settings.width = '100%'
      settings.style = {
        maxWidth: '960px'
      }
    }

    return settings
  }
}

export default SelectionModal
